let amplifyConfig;

const appEnv = process.env.APP_ENV || process.env.NODE_ENV || 'development'; // Default to "development" if not set

switch (appEnv) {
  case "production":
    amplifyConfig = require("../amplify_outputs_prod.json");
    break;
  case "test":
    amplifyConfig = require("../amplify_outputs_test.json");
    break;
  default:
    amplifyConfig = require("../amplify_outputs_dev.json");
}

console.log(`Amplify Config is loaded for APP_ENV: ${appEnv}`);
module.exports = amplifyConfig;
